import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

// Importar componentes
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './components/pages/Home/Home';
import Services from './components/pages/Services/Services';
import About from './components/pages/About/About';
import Contact from './components/pages/Contact/Contact';

// Componente para manejar el layout con header y footer
const Layout = ({ children }) => {
  const location = useLocation();
  
  // Obtener la página actual basada en la ruta
  const getCurrentPage = () => {
    const path = location.pathname;
    if (path === '/') return 'inicio';
    if (path === '/servicios') return 'servicios';
    if (path === '/nosotros') return 'nosotros';
    if (path === '/contacto') return 'contacto';
    return 'inicio';
  };

  return (
    <>
      <Header currentPage={getCurrentPage()} />
      <main className="App-main">
        {children}
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/servicios" element={<Services />} />
            <Route path="/nosotros" element={<About />} />
            <Route path="/contacto" element={<Contact />} />
            {/* Ruta por defecto para 404 */}
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
      </div>
    </Router>
  );
}

export default App;